import { Link } from "react-router";
import styles from "./logo.module.css";

export function Logo({ to = "/" }: { to?: string }) {
  return (
    <Link to={to} className={styles.logo} aria-label="YourCV">
      <span className={styles.mark} aria-hidden="true" />
      <span>YourCV</span>
    </Link>
  );
}
